/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioStatus } from './InternalApiScenarioStatus';
import {
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusFromJSONTyped,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioStatusToJSONTyped,
} from './InternalApiScenarioStatus';

/**
 * 
 * @export
 * @interface InternalApiRiskRuleUpdate
 */
export interface InternalApiRiskRuleUpdate {
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRuleUpdate
     */
    name?: string;
    /**
     * 
     * @type {InternalApiScenarioStatus}
     * @memberof InternalApiRiskRuleUpdate
     */
    status?: InternalApiScenarioStatus;
}



/**
 * Check if a given object implements the InternalApiRiskRuleUpdate interface.
 */
export function instanceOfInternalApiRiskRuleUpdate(value: object): value is InternalApiRiskRuleUpdate {
    return true;
}

export function InternalApiRiskRuleUpdateFromJSON(json: any): InternalApiRiskRuleUpdate {
    return InternalApiRiskRuleUpdateFromJSONTyped(json, false);
}

export function InternalApiRiskRuleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRiskRuleUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : InternalApiScenarioStatusFromJSON(json['status']),
    };
}

export function InternalApiRiskRuleUpdateToJSON(json: any): InternalApiRiskRuleUpdate {
    return InternalApiRiskRuleUpdateToJSONTyped(json, false);
}

export function InternalApiRiskRuleUpdateToJSONTyped(value?: InternalApiRiskRuleUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': InternalApiScenarioStatusToJSON(value['status']),
    };
}

